let id = 0
const MAX_EVENTS = 50

interface EventBufferInterface {
  getEvents(): CustomEvent[]
  pushEvent(id: number, event: CustomEvent): EventBufferInterface
  findById(id: number): undefined | CustomEvent
  getAllByType(type: string): CustomEvent[]
  popById(id: number): undefined | CustomEvent
  clear(): EventBufferInterface
  getLength(): number
}

class EventBuffer implements EventBufferInterface {
  private events: CustomEvent[] = []

  getEvents() {
    return this.events
  }

  getLength(): number {
    return Object.keys(this.events).length
  }

  pushEvent(id: number, event: CustomEvent): EventBufferInterface {
    this.events[id] = event
    if (this.getLength() > MAX_EVENTS) {
      this.removeFirst()
    }

    return this
  }

  findById(id: number): undefined | CustomEvent {
    if (id in this.events) {
      return this.events[id]
    }
  }

  getAllByType(type: string): CustomEvent[] {
    return this.events.filter(customEvent => typeof customEvent.type === type)
  }

  popById(id: number): undefined | CustomEvent {
    if (id in this.events) {
      const customEvent = this.events[id]
      delete this.events[id]
      return customEvent
    }
  }

  clear(): EventBufferInterface {
    this.events = []
    return this
  }

  private removeFirst() {
    if (this.getLength() > 0) {
      const firstIndex: string | undefined = Object.keys(this.events)[0]
      if (typeof firstIndex === 'string') {
        delete this.events[parseInt(firstIndex)]
      }
    }
  }
}

const buffer = new EventBuffer()

export default function useEventBuffer() {
  function initializeEventBuffer() {
    window.anzu = window.anzu || {}
    window.anzu.forum = window.anzu.forum || {}
    window.anzu.forum.handler = window.anzu.forum.handler || {}
    window.anzu.forum.handler.cmd = buffer
    buffer.clear()
    id = new Date().getTime()
  }

  function getNextId(): number {
    return id++
  }

  function dispatchEvent(eventName: string, detail: Record<string, any>) {
    const id = getNextId()
    detail['eventId'] = id
    const event = new CustomEvent(eventName, {
      detail: detail,
    })
    buffer.pushEvent(id, event)
    window.dispatchEvent(event)
  }

  return {
    initializeEventBuffer,
    dispatchEvent,
  }
}
